module.exports = __webpack_public_path__ + "static/media/One side Angle's Class III 7.4403c210.png";